// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".cls-1[data-v-207d15c6]{fill:#d0d0d0}.cls-2[data-v-207d15c6]{fill:var(--v-primary-base)}.cls-3[data-v-207d15c6]{fill:#febf7c}.cls-4[data-v-207d15c6]{fill:#e8e8e8}.cls-5[data-v-207d15c6]{fill:#fff3e7}.cls-6[data-v-207d15c6]{fill:#9e653e}.cls-7[data-v-207d15c6]{fill:#835637}", ""]);
// Exports
module.exports = exports;
